var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/website") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M7.05279391,13.0010636 L3.05500569,13.0006955 C3.46835632,16.7372697 6.16921492,19.7842959 9.72607502,20.7102675 C8.2052792,18.4233136 7.28166193,15.7770381 7.05279391,13.0010636 Z M20.9449943,13.0006955 L16.9498422,13.0008226 C16.7255335,15.7635472 15.8008579,18.4154858 14.2745676,20.7097575 C17.8312897,19.7837266 20.5316823,16.7369207 20.9449943,13.0006955 Z M14.9451328,13.0010123 L9.05769292,13.0010946 C9.30890222,15.7121312 10.3292401,18.2950493 11.9967971,20.4450756 C13.676649,18.2873482 14.6988051,15.6962979 14.9451328,13.0010123 Z M9.72543244,3.29024251 L9.6892238,3.29941009 C6.15025532,4.23685972 3.46644779,7.27618877 3.05489527,11.0003032 L7.05007662,11.0001782 C7.27424317,8.2370933 8.19895783,5.58479128 9.72543244,3.29024251 Z M12.0032029,3.55492436 C10.3233505,5.71297385 9.30093572,8.30447055 9.05476366,11.0001863 L14.9423997,10.9999049 C14.6913486,8.28850364 13.6709649,5.70521489 12.0032029,3.55492436 Z M14.273925,3.2897325 L14.4629614,3.58063524 C15.8714653,5.80010201 16.728192,8.34051478 16.9472885,10.9999359 L20.9451047,11.0003032 C20.5321249,7.26327319 17.831102,4.21578659 14.273925,3.2897325 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.cebfcd7f4df2b71a6061d1e1bc012393.svg";
export { ForwardRef as ReactComponent };